import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

const client = createClient('/rest/operator-api/charging-stations');

export const removeFromLocation: SaveOperation<void, void, string> = postRequestFactory<void, void, string>(
  client,
  {
    pattern: '/{chargingStationId}/remove-from-location',
    permissionId: commandPermissions.REMOVE_CHARGING_STATION_FROM_LOCATION
  }
);
